import React from 'react';
import dateFormat, { masks } from "dateformat";
class CostSheetMasterDetailView extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      
    <div>
      
      <p className='col1'>OW CONDITION:</p><p className='col2'>{this.props.data.data.CONDITION}</p>
      <p className='col1'>DG CONDITION:</p><p className='col2'>{this.props.data.data.DG_CONDITION}</p>
      <p className='col1'>REMARK:</p><p className='col2'>{this.props.data.data.REMARK}</p>
      <p className='col1'>UPDATE BY:</p><p className='col2'>{this.props.data.data.CREATE_BY}</p>
      <p className='col1'>UPDATE DATE:</p><p className='col2'>{dateFormat(this.props.data.data.CREATE_DATE,"dd-mmm-yyyy")}</p>
      </div>
    );
  }
}

export default CostSheetMasterDetailView;
